/* eslint-disable react/prop-types */
import * as React from 'react';
import { Button, Container } from '@mui/material';
import MaterialTable from 'material-table';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { findStripeTransfers } from '../api/venue-transactions-actions';
import { convertCentsToDollars, parseTimestamp } from './utils';

const headerStyle = {
  color: 'black',
  fontSize: '16px',
  fontWeight: 'bold',
};

export default function Transfers({ userOwner }) {
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const { eventId } = useParams();

  const getList = async (eventIdParam) => {
    setLoading(true);
    const response = await findStripeTransfers(eventIdParam);
    if (response) setList(response);
    setLoading(false);
  };

  useEffect(() => {
    getList(eventId);
  }, [eventId]);

  const stripeAccountId = userOwner?.stripe_details?.stripe_account_id;

  const listTable = list.map((item) => ({
    amount: convertCentsToDollars(item.amount),
    currency: item.currency,
    destination_payment: (
      <Button
        target="_blank"
        href={`https://dashboard.stripe.com/connect/accounts/${stripeAccountId}/payments/${item.destination_payment}`}
        variant="contained"
        disabled={!item.id || !stripeAccountId}>
        {item.destination_payment}
      </Button>
    ),
    date: parseTimestamp(item.created),
    actions: (
      <Button
        target="_blank"
        href={`https://dashboard.stripe.com/connect/transfers/${item.id}`}
        variant="contained"
        disabled={!item.id}>
        View in Stripe
      </Button>
    ),
  }));

  const totalAmount = list.reduce((acc, item) => acc + item.amount, 0);

  return (
    <Container>
      <div>
        <h3>Total Amount: {convertCentsToDollars(totalAmount)}</h3>
      </div>
      <MaterialTable
        isLoading={loading}
        title="Payments"
        columns={[
          { title: 'Amount', field: 'amount', headerStyle },
          { title: 'Currency', field: 'currency', headerStyle },
          { title: 'Payment', field: 'destination_payment', headerStyle },
          { title: 'Date', field: 'date', headerStyle },
          {
            title: 'Actions',
            field: 'actions',
            headerStyle,
          },
        ]}
        data={listTable}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 20, 50],
        }}
      />
    </Container>
  );
}
